"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'Kanon Digital Collection',
    organizationId: 'shizQkBFCglpj5ukxE1r',
    applicationKey: 'kanonshizaki',
    applicationType: 'standalone',
    artistId: '3jDMhZ97gzMyd5PXOcPmWy2A4HI2',
    theme: { dark: true },
    version: '1.1',
    ionicAppId: '41f91b77',
    platform: ['web', 'native'],
    ios: {
        bundleId: 'com.utoniq.kanonshizaki',
        appId: '6448008300',
    },
    android: {
        // kanonshizakiは限定公開で作成してしまったため、kanonshizaki2を正式なバンドルとして使用
        bundleId: 'com.utoniq.kanonshizaki2',
    },
    deeplinkUrl: 'https://kanonshizaki.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/3564140',
    deeplinkProd: 'kanonshizaki.utoniq.com',
    custom: {
        modules: {
            trade: true,
            thread: true,
            prepaidPoint: { chargeable: true },
            gacha: true,
            item: true,
            store: true,
            mission: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
            'images/tutorial/Tutorial04.jpg',
        ],
        globalTabs: [],
        artistTabs: ['home', 'collections', 'gachas', 'trade', 'myProfile'],
    },
});
